import { useEffect, useState } from "react";

// Fixed, real deadline (no localStorage tricks): meal plan launch week ends
// 2026-07-13 23:59:59 Europe/Berlin. After that the timer renders nothing —
// remove it or change the regular price, but never let it lie.
const DEADLINE = Date.UTC(2026, 6, 13, 21, 59, 59);

export const CountdownTimer = ({ label = "LAUNCH WEEK ENDS IN" }) => {
  const [remaining, setRemaining] = useState(() => DEADLINE - Date.now());

  useEffect(() => {
    const t = setInterval(() => setRemaining(DEADLINE - Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (remaining <= 0) return null;

  const d = Math.floor(remaining / 86400000);
  const h = Math.floor((remaining % 86400000) / 3600000);
  const m = Math.floor((remaining % 3600000) / 60000);
  const s = Math.floor((remaining % 60000) / 1000);
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div data-testid="countdown-timer" className="border border-[#D90429] bg-[#D90429]/10 px-4 py-2.5 flex items-center justify-center gap-3 flex-wrap">
      <span className="font-jet text-[10px] tracking-[0.3em] text-[#D90429]">{label}</span>
      <span className="font-jet text-lg font-bold text-[#F5F5F5] tabular-nums" style={{ textShadow: "0 0 12px rgba(217,4,41,0.8)" }}>
        {d}d {pad(h)}:{pad(m)}:{pad(s)}
      </span>
    </div>
  );
};
